function toggleSignUpDrawer(drawerToggleSelector, drawerContentSelector, closeButtonSelector) {
    const drawerToggle = document.querySelector(drawerToggleSelector);
    const drawerContent = document.querySelector(drawerContentSelector);
    const closeButton = document.querySelector(closeButtonSelector);
    const body = document.body;

    function openDrawer() {
        drawerToggle.classList.add('drawer-menu-opening');
        drawerContent.classList.add('open');
        body.classList.add('signup-drawer-open');
    }

    function closeDrawer() {
        drawerToggle.classList.remove('drawer-menu-opening');
        drawerContent.classList.remove('open');
        body.classList.remove('signup-drawer-open');
    }

    if (drawerToggle) {
        
        drawerToggle.addEventListener('click', function (event) {
            event.preventDefault();
            drawerToggle.classList.contains('drawer-menu-opening') ? closeDrawer() : openDrawer();
        });
    }
        
    $(closeButton).on('click', function (event) {
        event.preventDefault();
        closeDrawer();
    });
}

function initSignUpDrawer() 
{
    toggleSignUpDrawer('.wi-signup-drawer-wrapper', '.wi-right-header-close-button');
    toggleSignUpDrawer('.header__icon.wi-mobile-drawer-signup-icon', '.wi-mobile-menu-signup-drawer', '.wi-mobile-signup-close-button');
}


function VipInfoPopup() 
{
    $('.question_icon').click(function (e) 
    { 
        e.preventDefault();
        $('.vip_info_popup').addClass('active');
        $('body').addClass("overflow-hidden");
    });

    $('.vip_popup_close_button').click(function (e) 
    { 
        e.preventDefault();
        $('.vip_info_popup').removeClass('active');
        $('body').removeClass("overflow-hidden");
    });
}

$(document).ready(function () 
{   
    initSignUpDrawer();

    // product page js
    VipInfoPopup();

    // Announcement bar tabs active feature
    // $('.wi_announcement_tabs span.tab').click(function (e) 
    // { 
    //     e.preventDefault();
    //     $('.wi_announcement_tabs span.tab').removeClass('active');
    //     $(this).addClass('active');
    // });

    $('.wi_icon.product-popup-modal__button').click(function (e) { 
        e.preventDefault();
        $('.wi_video_modal[open] video').trigger('play');
    });

    
    $('.sound_high.product-popup-modal__toggle').click(function (e) 
    { 
        e.preventDefault();
        $(this).addClass('hidden');
        $(this).next('.sound_muted').removeClass('hidden');
        $(".wi_video_modal[open] video").prop('muted', true);
    });

    $('.sound_muted.product-popup-modal__toggle').click(function (e) 
    { 
        e.preventDefault();
        $(this).addClass('hidden');
        $(this).parents('.wi_video_modal').find('.sound_high').removeClass('hidden');
        $(".wi_video_modal[open] video").prop('muted', false);
    });
    
    // $(document).on("click",".wi_signin_button",function() 
    // {
    //     document.querySelector('.header__icon.wi-header-right-signup-icon').classList.add('drawer-menu-opening');
    //     document.querySelector('.wi-signup-drawer-wrapper').classList.add('open');
    //     document.body.classList.add('signup-drawer-open');
    // });
    $(document).on("click",".wi_signin_button_cart",function() 
    {
        document.querySelector('.header__icon.wi-header-right-signup-icon').classList.add('drawer-menu-opening');
        document.querySelector('.wi-signup-drawer-wrapper').classList.add('open');
        document.body.classList.add('signup-drawer-open');
        $('.cart-drawer-container').removeClass('menu-opening');
    });
    $(document).on("click",".password_eye_icon",function()
    {
        var input = $('.password_field');
        if (input.attr('type') == 'password') 
        {
            input.attr('type', 'text');
            $('.password_eye_slash_icon').addClass('active');
            $('.password_eye_open_icon').removeClass('active');
        } 
        else 
        {
            input.attr('type', 'password');
            $('.password_eye_slash_icon').removeClass('active');
            $('.password_eye_open_icon').addClass('active');
        }
        
    });


    $(document).on("click", function(e) 
    {
        
        if ($(e.target).hasClass('facets__header')) 
        {
            if ($(e.target).parent().attr('open')) 
            {
                $(e.target).parents('details').removeAttr('open');
                return false;
            }
        }
        else
        {
            if (!$(e.target).closest('.custom_horizontal_facets__list').length && !$(e.target).closest('details').length) 
            {
                $('.custom_horizontal_filter details[open]').removeAttr('open');
            }
        }
   
    }); 

      

});